import { createFileRoute } from "@tanstack/react-router";
import { ComingSoonPage } from "@/components/layout/page-container.tsx";

export const Route = createFileRoute("/sdk")({
  component: () => <ComingSoonPage title="SDK 中心" />,
});
